import { Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, makeStyles, Typography } from '@material-ui/core';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { archiveRideById, getAllRidesInProcess } from '../../store/actions/RideActions';
import { CREATED_AT, DESC, ID, START_ANALYSIS_URL, TODO_ANALYZES_URL, UPDATED_AT, useIsComponentMounted, USER_EMAIL } from '../../utils/AppUtils';
import { useNavigate, useLocation } from 'react-router-dom';
import { Pagination, Stack } from '@mui/material';
import { ACTION_TYPES as RIDE_ACTION_TYPES } from '../../store/reducers/RideReducer';
import { ACTION_TYPES as USER_ACTION_TYPES } from '../../store/reducers/UserReducer';
import { getUserByRideId } from '../../store/actions/UserActions';
import TableCommon from '../TableCommon';
import { DataGrid } from '@mui/x-data-grid';
import SearchBar from '../SearchBar';
import { useBetween } from 'use-between';
import { useShareableState } from '../utils/SharableStates';
import { ACTION_TYPES } from '../../store/reducers/UtilsReducer';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            padding: '4rem 0px',
            position: 'relative',
        },
        link: {
            padding: '0.5rem 0.9rem',
            color: 'white',
            backgroundColor: 'rgb(245 179 53)',
            textDecoration: 'none',
            fontSize: '.875rem',
            borderRadius: '0.3rem',
            fontWeight: '500',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '0 10px 0 0'   
        },
        buttonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
        },
        iconButton: {
            padding: '5px 10px',
            backgroundColor: 'red',
            borderRadius: '0.3rem',
            '&:hover': {
                backgroundColor: 'red'
            }
        },
        deleteIcon: {
            
        },
        dialogRoot: {
            '& .MuiBackdrop-root':{
                backgroundColor: 'rgba(0, 0, 0, 0.02)'
            },
            '& .MuiDialog-scrollPaper': {
                '& .MuiPaper-elevation24': {
                    boxShadow: '0px 0px 0px 0px rgba(0,0,0,0.2)'
                }
            }
        },
        dialogButtonsContainer: {
            display: 'flex',
            justifyContent: 'center',
            padding: 15
        },
        buttonArchive: {
            backgroundColor: 'red',
            color: 'white',
            margin: '0 10px 0 0',
            '&:hover': {
                backgroundColor: 'red'
            }
        },
        buttonRegret: {
            backgroundColor: 'green',
            color: 'white',
            '&:hover': {
                backgroundColor: 'green'
            }
        },
        buttonClose: {
            color: 'white',
            backgroundColor: 'rgb(245 179 53)',
            '&:hover': {
                backgroundColor: 'rgb(245 179 53)'
            }
        },
        imageWrapper: {
            display: 'flex',
            justifyContent: 'center',
            '& .MuiSvgIcon-root':{
                fontSize: '4rem'
            }
        }
    }
})

function AnalyzesToDo({ getAllRidesInProcess, loading, rides, totalNumOfRides, isAuthenticated, getUserByRideId, user, archiveRideById, reRender, errorMessage, status, searchTerm}) {
    const classes = useStyles();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //Set 'updated_at' as initial sortField for this component
    const [sort, setSort] = useState({
        field: UPDATED_AT,
        sortDirection: DESC
    })
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });
    const [open, setOpen] = useState(false);
    const [rideIdToArchive, setRideIdToArchive] = useState(null);
    const [errorMsg,setErrorMsg] = useState('');
    const {startSearch, setStartSearch} = useBetween(useShareableState)
    const [tempSearchTerm, setTempSearchTerm] = useState('');

    const handleClickOpen = (rideId) => {
        setRideIdToArchive(rideId);
        dispatch({ type: RIDE_ACTION_TYPES.SET_STATUS_TO_NULL }) 
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
        dispatch({ type: RIDE_ACTION_TYPES.SET_ERROR_MESSAGE_TO_NULL})
    };

    const handleArchiveRide = () => {
       //Set reRender prop to false. It will then be set to true if request to archive ride is succesful. This way makes it possible to reload table when a ride is archived
        dispatch({ type: RIDE_ACTION_TYPES.SET_RERENDER_AS_FALSE })
        dispatch({ type: RIDE_ACTION_TYPES.SET_LOADING_AS_TRUE })
        archiveRideById(rideIdToArchive)
        setRideIdToArchive(null);
    };

    //Columns to use as header for table
    const columns = [
        { field: ID, headerName: 'Ride ID', flex: 0.1, headerClassName: 'super-app-theme--header' },
        { field: USER_EMAIL, headerName: 'Användare', flex: 0.2, headerClassName: 'super-app-theme--header' },
        { field: UPDATED_AT, headerName: 'Datum för köp', flex: 0.2, headerClassName: 'super-app-theme--header' },
        { field: CREATED_AT, headerName: 'Skapad', flex: 0.3, headerClassName: 'super-app-theme--header' },
        { 
            renderCell: (params) => {
                return (
                    <div className={classes.buttonsContainer}>
                        <NavLink className={classes.link} to={START_ANALYSIS_URL + params.row.id}>Gå vidare</NavLink>
                        <IconButton className={classes.iconButton} onClick={() => handleClickOpen(params.row.id)}>
                            <DeleteForeverIcon sx={{ color: 'white' }} className={classes.deleteIcon} fontSize="medium"/>
                        </IconButton>
                        <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            classes={{root: classes.dialogRoot}}
                        >
                            {
                                !loading && !errorMsg && !status ? 
                                    <div>
                                        <DialogTitle id="alert-dialog-title">
                                        {"Är du säker på att du vill arkivera denna ritt?"}
                                        </DialogTitle>
                                        <DialogContent>
                                        <DialogContentText id="alert-dialog-description">
                                            En arkiverad ritt innebär att all insamlad data och historik kommer att finnas kvar, men den kommer inte vara synlig varken i shopen eller i webtoolet.
                                        </DialogContentText>
                                        </DialogContent>
                                        <DialogActions className={classes.dialogButtonsContainer}>
                                            <Button className={classes.buttonArchive} variant='contained' onClick={handleArchiveRide}>Arkivera</Button>
                                            <Button className={classes.buttonRegret} variant='contained' onClick={handleClose} autoFocus>
                                                Ångra val
                                            </Button>
                                        </DialogActions>
                                    </div>
                                : !loading && errorMsg ? 
                                    <div>
                                        <DialogTitle id="alert-dialog-title">
                                        {errorMessage}
                                        </DialogTitle>
                                        <DialogContent>
                                                <div className={classes.imageWrapper}>
                                                    <ErrorIcon className={classes.errorIcon} color='error'/>
                                                </div>
                                        </DialogContent>
                                        <DialogActions className={classes.dialogButtonsContainer}>
                                            <Button className={classes.buttonClose} variant='contained' onClick={handleClose} autoFocus>
                                                Stäng
                                            </Button>
                                        </DialogActions>
                                    </div>
                                : !loading && status === 200 ? 
                                    <div>
                                        <DialogTitle id="alert-dialog-title">
                                        {"Ritten har nu blivit arkiverad!"}
                                        </DialogTitle>
                                        <DialogContent>
                                            <div className={classes.imageWrapper}>
                                                <CheckCircleIcon className={classes.successIcon} color='success'/>
                                            </div>
                                        </DialogContent>
                                        <DialogActions className={classes.dialogButtonsContainer}>
                                            <Button className={classes.buttonClose} variant='contained' onClick={handleClose} autoFocus>
                                                Stäng
                                            </Button>
                                        </DialogActions>
                                    </div>
                                : null
                               
                            }
                        </Dialog>
                    </div>
                    
                )
            },
            field: "buttons",
            headerName: "",
            flex: 0.15,
            sortable: false,
            disableColumnMenu: true,
            headerClassName: 'super-app-theme--header'
        }
    ];
    
    if (location.pathname !== TODO_ANALYZES_URL) {
        navigate(TODO_ANALYZES_URL)
    }

    useEffect(() => {
        getAllRidesInProcess(paginationModel, navigate, sort, tempSearchTerm);
    }, [paginationModel, sort, reRender]);
    

    useEffect(() => {
        if(startSearch) {
            setTempSearchTerm(searchTerm)
            getAllRidesInProcess(paginationModel, navigate, sort, searchTerm);
            setStartSearch(false)
        }
    }, [searchTerm]);

    useEffect(() => {
        setErrorMsg(errorMessage)
    }, [errorMessage]);

    useEffect(() => {
        return () => {
            dispatch({type: RIDE_ACTION_TYPES.CLEAR_RIDES })
            dispatch({type: RIDE_ACTION_TYPES.CLEAR_TOTAL_NUMBER_OF_RIDES})
            dispatch({ type: RIDE_ACTION_TYPES.SET_ERROR_MESSAGE_TO_NULL})
            dispatch({ type: RIDE_ACTION_TYPES.SET_STATUS_TO_NULL})
            dispatch({ type: RIDE_ACTION_TYPES.SET_RERENDER_AS_FALSE })
            dispatch({ type: ACTION_TYPES.UPDATE_SEARCH_TERM, payload: '' })
        }
    },[]);

    const handleSortModelChange = (sortModel) => {
        let sort = sortModel[0];
        setSort({
            field: sort.field,
            sortDirection: sort.sort
        }) 
    }

    const handlePaginationModelChange = (paginationModel) => {
        setPaginationModel({
            page: paginationModel.page,
            pageSize: paginationModel.pageSize
        })
        
    }

    return (

        <div className={classes.root}>
            {!loading && rides && totalNumOfRides !== null ?
                <div>
                    <Typography variant='h1'>Analyser att göra</Typography>
                    <Typography variant='body1'>Här ser du alla ritter som kunder har beställt analys av. Tryck på "Gå till analys" för att påbörja en analys för en specifik ritt.</Typography>
                    <br></br>
                    <SearchBar />
                    <TableCommon 
                        columns={columns} 
                        rows={rides.map(ride => ({
                            id: ride.id,
                            userEmail: ride.userEmail,
                            updatedAt: new Date(Date.parse(ride.updatedAt)).toLocaleString("sv-SE").toString(),
                            createdAt: new Date(Date.parse(ride.createdAt)).toLocaleString("sv-SE").toString()
                        }))} 
                        loading={loading} 
                        totalElements={totalNumOfRides}
                        handleSortModelChange={handleSortModelChange}
                        handlePaginationModelChange={handlePaginationModelChange}
                        paginationModel={paginationModel}
                    />
                         
                </div>
                :
                <Stack sx={{ color: 'grey.500', position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} spacing={2} direction="row">
                    <CircularProgress color="inherit" />
                </Stack>
            }
        </div>
    )
}

const mapStateToProps = ({ ride, auth, user,utils }) => ({
    rides: ride.ridesInProcess,
    loading: ride.loading,
    totalNumOfRides: ride.totalNumOfRides,
    isAuthenticated: auth.isAuthenticated,
    user: user.user,
    reRender: ride.reRender,
    errorMessage: ride.errorMessage,
    status: ride.status,
    searchTerm: utils.searchTerm
})

const mapDispatchToProps = (dispatch) => {
    return {
        getAllRidesInProcess: (pagination, navigate, sort, searchTerm) => dispatch(getAllRidesInProcess(pagination, navigate, sort, searchTerm)),
        archiveRideById: (rideId) => dispatch(archiveRideById(rideId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyzesToDo);